module.exports = __webpack_public_path__ + "8109ddc4f09423cea9324e227333a4eb.svg";